import { LabelType } from '../../../../../elements/public_api';
import { Cell, CellType } from '../_base/table-cell.entity';

export class ProgressCell extends Cell {
    constructor(
        public readonly value: string,
        public readonly labelType: LabelType,
        public readonly percentage: number = 0
    ) {
        super(CellType.PROGRESS);
    }
}
